<div class="card rounded border">
  <ng-container *ngIf="member$ | async as member">
    <div>
      <label class="mb-0">{{ 'account.details.dob' | translate }}</label>
      <div class="account-item d-flex bg-muted p-2 m-0 rounded">
        <span class="icon material-icons" aria-hidden="true">date_range</span>
        <span class="ms-3 font-size-12 text-black d-flex align-items-center">{{ member.DOB | date: 'MMM d, YYYY' }}</span>
      </div>
    </div>
    <div>
      <label class="mb-0 mt-3 personal-info">{{ 'account.details.email' | translate }}</label>
      <div class="account-item d-flex bg-muted p-2 m-0 rounded">
        <span class="icon material-icons" aria-hidden="true">email</span>
        <span class="ms-3 font-size-12 text-black d-flex align-items-center">{{ member.EmailAddress1 }}</span>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
